import React, { Component } from "react";
import { shape, object } from "prop-types";
import Control from "ol/control/Control";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";

const dataSelector = state => state.map.get("selectedResource");
const resourceSelector = createSelector(
  dataSelector,
  _.identity
);

const styles = theme => ({
  control: {
    zIndex: 1000,
    top: ".5em",
    right: "1em",
    position: "absolute",
    width: 300,
    height: "auto"
  },
  paper: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: 10,
    paddingRight: 0,
    width: 300,
    height: "auto"
  },
  paperFull: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: 10,
    paddingRight: 0,
    width: 300,
    height: "auto"
  },
  controlFull: {
    zIndex: 1000,
    top: ".5em",
    right: "1em",
    position: "absolute",
    width: 300,
    height: "auto"
  }
});

class SelectedResourceOverlay extends Component {
  static propTypes = {
    map: shape(),
    classes: object.isRequired
  };

  controlRef = React.createRef();

  componentDidMount() {
    const { map } = this.props;
    const control = new Control({
      element: this.controlRef.current
    });

    map.addControl(control);
  }

  render() {
    const { classes, resource } = this.props;
    const resourceProps = _.get(resource, "props");
    const resourceStats = _.get(resource, "stats");
    const containerName = _.get(resourceProps, "containerName");
    const resourceName = _.get(resourceProps, "resourceName");
    const resourceValue = _.get(resourceStats, "currentValue", 0);
    const resourceProbability = _.get(resourceStats, "currentProbability", 0);
    const resourceDescription = _.get(resourceStats, "currentDescription", "");
    if (_.isEmpty(resource)) {
      return <div ref={this.controlRef} />;
    } else {
      return (
        <div
          className={resourceStats ? classes.controlFull : classes.control}
          ref={this.controlRef}
        >
          <Paper
            classes={{
              root: resourceStats ? classes.paperFull : classes.paper
            }}
            elevation={1}
          >
            {containerName ? (
              <Typography component="h3">
                {containerName}
              </Typography>
            ) : null}
            {resourceName ? (
              <Typography component="p">{resourceName}</Typography>
            ) : null}
            {resourceStats ? (
              <React.Fragment>
                <Typography component="p">
                  {_.round(resourceValue, 2)}; PrP:{" "}
                  {_.round(resourceProbability, 2).toFixed(2)}
                </Typography>
                <Typography component="p">{resourceDescription}</Typography>
              </React.Fragment>
            ) : null}
          </Paper>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    resource: resourceSelector(state),
    year: state.filters.get("year")
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(SelectedResourceOverlay);



// WEBPACK FOOTER //
// ./src/components/map/selectedResourceOverlay.js